import React from "react";
import { StyledCheckbox } from "../styledComponents/StyledCheckbox";

function CheckboxWithText({ text = "", subtext = "", checked = false, onChange, testId }) {
  return (
    <StyledCheckbox>
      <input data-testid={testId} onChange={onChange} checked={checked} type="checkbox" />
      <label>
        <b>{text}</b>
      </label>
      <p>{subtext}</p>
    </StyledCheckbox>
  );
}

export default CheckboxWithText;
